import { render, staticRenderFns } from "./contract_template.vue?vue&type=template&id=158a05e4"
import script from "./contract_template.vue?vue&type=script&lang=js"
export * from "./contract_template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158a05e4')) {
      api.createRecord('158a05e4', component.options)
    } else {
      api.reload('158a05e4', component.options)
    }
    module.hot.accept("./contract_template.vue?vue&type=template&id=158a05e4", function () {
      api.rerender('158a05e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/contract_template/contract_template.vue"
export default component.exports